export const ScriptLoader = class ScriptLoader {
  constructor() {
    this.scripts = {};
  }

  loadScript(id, src, target, async = false) {
    return new Promise((resolve, reject) => {
      if (this.scripts[id]) {
        if (this.scripts[id].loaded) {
          resolve(this.scripts[id]);
        } else {
          this.scripts[id].callbacks.push({ resolve, reject });
        }
      } else {
        this.scripts[id] = { loaded: false, callbacks: [{ resolve, reject }] };
        const script = document.createElement('script');
        script.src = src;
        script.async = async;
        script.onload = () => {
          this.scripts[id].loaded = true;
          this.scripts[id].callbacks.forEach(({ resolve }) =>
            resolve(this.scripts[id])
          );
        };
        script.onerror = () => {
          reject(new Error(`Script load error for ${src}`));
        };
        document.querySelector(target).append(script);
      }
    });
  }
};
